import Observer, {IObserver, IObserverOptionsCommon} from '~/utils/observer'
import FormSubmissionWysiwygValue from '~/utils/formSubmissionWysiwygValue'

export interface IWysiwygObserverOptions<M> extends IObserverOptionsCommon<M> {
  wysiwyg: string
}

export interface IWysiwygObserver<M> extends IObserver<M> {
  clientIds: string[]
  type: 'wysiwyg'
  wysiwyg: string
}

export default class WysiwygObserver<M> extends Observer<M, IWysiwygObserverOptions<M>> implements IWysiwygObserver<M> {
  readonly type: 'wysiwyg' = 'wysiwyg'

  constructor(protected options: IWysiwygObserverOptions<M>) {
    super(options)
  }

  get wysiwyg(): string {
    return this.call("wysiwyg")
  }

  get clientIds(): string[] {
    return FormSubmissionWysiwygValue.parseClientIds(this.wysiwyg)
  }
}